import { useState } from 'react'
import { Button } from '../../components/ui'

const categories = ['Product docs', 'Legal', 'Marketing', 'Technical']

function DocumentForm({ products, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    product_id: products[0]?.id || '',
    title: '',
    url: '',
    category: categories[0],
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!formData.title || !formData.url) return
    onSubmit({
      ...formData,
      product_id: formData.product_id || null,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="stack">
      <div className="form-group">
        <label className="form-label">Product</label>
        <select
          className="form-select"
          name="product_id"
          value={formData.product_id}
          onChange={handleChange}
        >
          <option value="">General</option>
          {products.map(product => (
            <option key={product.id} value={product.id}>{product.name}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Title</label>
        <input
          className="form-input"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">URL</label>
        <input
          className="form-input"
          name="url"
          value={formData.url}
          onChange={handleChange}
          placeholder="https://docs.whenworks.com/overview"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Category</label>
        <select
          className="form-select"
          name="category"
          value={formData.category}
          onChange={handleChange}
        >
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>

      <div className="modal-actions">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={loading}>
          Add Document
        </Button>
      </div>
    </form>
  )
}

export default DocumentForm
